import { render, staticRenderFns } from "./reset-forgot-password.vue?vue&type=template&id=4c060dec&"
import script from "./reset-forgot-password.vue?vue&type=script&lang=js&"
export * from "./reset-forgot-password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports